var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-mobile"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mobile",
    clipPath: "url(#clip-mobile)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11427",
    "data-name": "Group 11427",
    transform: "translate(-16.855 -10.598)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11428",
    "data-name": "Group 11428",
    transform: "translate(26.859 15.05)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11372",
    "data-name": "Group 11372",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1672_",
    d: "M25.209,0H.887A.887.887,0,0,0,0,.887v13.22a.887.887,0,0,0,.887.887H25.209a.887.887,0,0,0,.887-.887V.887A.887.887,0,0,0,25.209,0Z",
    transform: "translate(14.994 0) rotate(90)",
    fill: "#FDC781"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29660",
    "data-name": "Rectangle 29660",
    width: 4.492,
    height: 1.123,
    rx: 0.561,
    transform: "translate(5.586 3.312)",
    fill: "#FDC781"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.8c39aa716c003f69fcba7c329354c582.svg";
export { ForwardRef as ReactComponent };